import { durationSeconds, frameCount, type PcmAudio } from "../types";

export interface TrimRange {
  /** Start of the kept region, in seconds (clamped to >= 0). */
  start: number;
  /** End of the kept region, in seconds (clamped to <= duration). */
  end: number;
}

/**
 * Return a new {@link PcmAudio} containing only the samples in `[start, end)`.
 *
 * Pure: operates on the decoded buffer, no Web Audio involved. Bounds are
 * clamped to the buffer; `start >= end` (after clamping) yields an empty buffer
 * with the same channel layout.
 */
export function trim(audio: PcmAudio, range: TrimRange): PcmAudio {
  const total = frameCount(audio);
  const duration = durationSeconds(audio);

  const startSec = Math.max(0, Math.min(range.start, duration));
  const endSec = Math.max(startSec, Math.min(range.end, duration));

  const startFrame = Math.floor(startSec * audio.sampleRate);
  const endFrame = Math.min(total, Math.floor(endSec * audio.sampleRate));

  const channelData = audio.channelData.map((channel) => channel.slice(startFrame, endFrame));

  return { sampleRate: audio.sampleRate, channelData };
}
